import { fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'

export const DATA_IS_LOADING = 'loader/DATA_IS_LOADING'
export const DATA_IS_LOADED = 'loader/DATA_IS_LOADED'
export const DATA_IS_EMPTY = 'loader/DATA_IS_EMPTY'

const initialState = fromJS({
  isLoading: false,
})

const loader = handleActions(
  {
    [DATA_IS_LOADING]: state => state.set('isLoading', true),
    [combineActions(DATA_IS_LOADED, DATA_IS_EMPTY)]: state =>
      state.set('isLoading', false),
  },
  initialState,
)

export default loader
